import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Inject,
  Input, OnDestroy,
  Optional,
  ViewChild
} from "@angular/core";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {BehaviorSubject, Observable, Subscription} from "rxjs";
import {INControlsTheme, N_THEME} from "../../services/theme";
import {NDropdownMenuComponent} from "../dropdown/n-dropdown-menu.component";

@Component({
  selector: "n-tabset",
  templateUrl: "./n-tabset.html",
  styleUrls: [
    "./n-tabset.css"
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NTabsetComponent),
      multi: true
    }
  ]
})
export class NTabsetComponent implements ControlValueAccessor, OnDestroy {

  /**
   * сворачивание в селект на мобиле
   */
  @Input() selectable: boolean;
  /**
   * другой вид табов
   */
  @Input() switchable: boolean;
  /* todo другой вид табов */
  @Input() mod: "float" | "onLine" | "switcher" | "buttonSwitcher" = "float";
  selectorTitle$ = new BehaviorSubject("");
  selectorCount$ = new BehaviorSubject(null);
  noSelectedTabs = false;
  theme: INControlsTheme;
  @ViewChild(NDropdownMenuComponent, {static: true})
  dropdownMenu: NDropdownMenuComponent;

  private propagateChange: (_) => void;
  panes: INTabPane[] = [];
  private currentModelValue: any;
  private subscriptions: Subscription[] = [];
  private selectedPane: INTabPane;

  constructor(@Inject(N_THEME) @Optional() theme: INControlsTheme) {
    this.theme = theme;
  }

  addPane(pane: INTabPane) {
    this.panes.push(pane);
    if (this.currentModelValue && this.currentModelValue === pane.id) {
      this.markPaneAsSelected(pane);
    }
  }

  removePane(pane: INTabPane) {
    const index = this.panes.indexOf(pane);
    if (index >= 0) {
      this.panes.splice(index, 1);
    }
  }

  selectPane(paneToSelect: INTabPane) {
    this.markPaneAsSelected(paneToSelect);
    this.setSelectedPane(paneToSelect);
  }

  writeValue(val: any): void {
    this.currentModelValue = val;

    for (let i = 0; i < this.panes.length; i++) {
      const pane = this.panes[i];
      if (pane.id && pane.id === val || pane === val) {
        this.markPaneAsSelected(pane);
        return;
      }
    }
    this.markPaneAsSelected(null);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  markFocusedMenu() {
    this.dropdownMenu.setFocusedItemIndex(this.panes.indexOf(this.selectedPane));
  }

  optionIdentity(index: number, item: INTabPane) {
    return item.id || item;
  }

  private setSelectedPane(pane: INTabPane) {
    if (this.propagateChange) {
      this.propagateChange(pane ? pane.id || pane : undefined);
    }
  }

  private markPaneAsSelected(paneToSelect: INTabPane) {
    this.selectedPane = paneToSelect;
    for (let i = 0; i < this.panes.length; i++) {
      const pane = this.panes[i];
      if (pane !== paneToSelect) {
        pane.setSelected(false);
      }
    }

    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.subscriptions = [];

    if (paneToSelect) {
      paneToSelect.setSelected(true);
      this.selectorTitle$.next(paneToSelect.headingSnapshot());
      this.subscriptions.push(paneToSelect.count$.subscribe(val => this.selectorCount$.next(val)));
      this.subscriptions.push(paneToSelect.heading$.subscribe(val => this.selectorTitle$.next(val)));
      this.noSelectedTabs = false;
    } else {
      this.selectorTitle$.next("Не выбрано"); // todo по-русски )))
      this.selectorCount$.next(undefined);
      this.noSelectedTabs = true;
      this.dropdownMenu.setFocusedItemIndex(-1);
    }
    this.markFocusedMenu();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

}


export interface INTabPane {

  readonly heading$: Observable<string>;
  readonly disabled$: Observable<boolean>;
  readonly iconId$?: Observable<string>;
  readonly iconColor$?: Observable<string>;
  readonly id: any;
  readonly select: EventEmitter<any>;
  readonly tid?: string;

  readonly count$: Observable<number>;

  headingSnapshot(): string;

  disabledSnapshot(): boolean;

  setSelected(set: boolean);
}
